export const environment = {
  production: false,
  apiUrl: 'https://apiv4.app.pulpitests.com/api/v4/app/',
  apiDomiciliation: 'https://domiciliation.pulpitests.com/api/v4/service/',

}
